import React, { useEffect, useState } from 'react';
import CurrencyTextField from '../../modulos/mascaraMoeda/CurrencyTextField';
import { useFormikContext } from 'formik';

export const calculaValorFinal = (valorBase, valorDesconto)=>{
    if (!valorBase){
        return '0';
    }

    if (!valorDesconto && valorBase){
        return valorBase;
    }

    valorBase = Number.parseFloat(valorBase.replace('R', '').replace('$', '').replace(',', '.'));
    valorDesconto = Number.parseFloat(valorDesconto.replace('R', '').replace('$', '').replace(',', '.'));

    const result = valorBase-valorDesconto;

    if (!result){
        return '0';
    }

    if (result < 0){
        return '0';
    }

    return result;
};

export const calculaValorFinalEdit = (valorBase, valorDesconto)=>{
    if (!valorBase){
        return '0';
    }

    if (!valorDesconto){
        return '0';
    }
    
    const result = valorBase-valorDesconto;

    if (!result){
        return '0';
    }
    
    if (result < 0){
        return '0';
    }

    return result;
};

export default function ValorFinalDesconto() {
    const { values, setFieldValue } = useFormikContext();
    const [valorFinal, setValorfinal] = useState();

    useEffect(() => {
        let { valorDesconto, valorBase } = values;

        if(typeof valorDesconto === 'string'){
            valorDesconto = parseFloat(valorDesconto.replace('.', '').replace(',','.'));
        }

        if(typeof valorBase === 'string'){
            valorBase = parseFloat(valorBase.replace('.', '').replace(',','.'));
        }

        const valorFinal = (calculaValorFinalEdit(valorBase, valorDesconto));

        setFieldValue('valorFinal', valorFinal);
    }, [values]);

    return (
        
        <CurrencyTextField
            label="Valor Final"
            id="valorFinal"
            name="valorFinal"
            variant="standard"
            currencySymbol="R$"
            decimalCharacter=","
            digitGroupSeparator="."
            style={{ width: '100%' }}
            disabled={true}
            value={values.valorFinal.toString()}
        />
    );
}
